import { Box, type BoxProps, Stepper, Title } from '@mantine/core'
import { type PropsWithChildren } from 'react'

import { useTranslation } from '@flecto/translations'

import { useOnboardingNavigation } from '../../hooks/useOnboardingNavigation'
import { useOnboardingStepsData } from '../../hooks/useOnboardingStepsData'

export function StepperVertical(props?: PropsWithChildren<BoxProps>) {
  const { currentStep, totalSteps, moveToStep } = useOnboardingNavigation()
  const { t } = useTranslation('saas', { keyPrefix: 'onboarding' })
  const steps = useOnboardingStepsData()

  return (
    <Box {...props} ml='lg'>
      <Title order={5} mb='md'>
        {t('onboarding_progress')}
      </Title>
      <Stepper
        active={currentStep - 1}
        onStepClick={(step) => {
          if (currentStep === totalSteps) {
            moveToStep(step + 1)
          }
        }}
        orientation='vertical'
        allowNextStepsSelect={false}
      >
        {steps.map(({ stepNumber, title }) => (
          <Stepper.Step
            key={`step-vertical-${stepNumber}`}
            label={`${t('step')} ${stepNumber}`}
            description={title}
          />
        ))}
        <Stepper.Step
          label={`${t('step')} ${steps.length + 1}`}
          description={t('steps.review_and_start.title')}
        />
      </Stepper>
    </Box>
  )
}
